import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      Operation: 'Operation',
      Common: 'Common',
      leftMenuShow:'leftMenuShow',
      docFontSize:'fontSize'
    })
  },
  methods: {
    ...mapMutations({
      SETOPTIONS: 'Operation/SETOPTIONS',
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      setLeftMenuIndex_M:"SET_LEFTMENU_INDEX",
      setSearchData_M:"Operation/setSearchData_M",
    }),
    ...mapActions({
      getTableList_A:"Operation/getTableList_A",
      getJobList_A:"Operation/getJobList_A",
      getUnitListForCreate_A:"Operation/getUnitListForCreate_A",
      createOrEditAccount_A:"Operation/createOrEditAccount_A",
      stopOrReuseAccount_A:"Operation/stopOrReuseAccount_A",
      unbindAcount_A:"Operation/unbindAcount_A",
      deleteAccount_A:"Operation/deleteAccount_A",
      confirmEnterpriseCustomer: "Operation/confirmEnterpriseCustomer"
    })

  }

}




// WEBPACK FOOTER //
// ./src/pages/PartI/OperationAccount/components/Mixins.js